export const DAY = 'DAY';
export const WEEK = 'WEEK';